import { FASTAccordionItem, MatchMediaStyleSheetBehavior } from '@microsoft/fast-foundation';
import { controlDensityStyles, controlShapeStyles, cornerRadiusLayer, focusStrokeOuter, focusStrokeThickness, neutralForegroundStrongElementStyles, plainTextStyles, strokeThickness } from '@adaptive-web/adaptive-ui/reference';
import {
  AccordionItemAnatomy,
  AccordionItemStatics,
  AdaptiveDesignSystem,
  DesignSystem,
  accordionItemTemplate,
  accordionItemTemplateStyles,
} from '@adaptive-web/adaptive-web-components';
import { Updates, css } from '@microsoft/fast-element';
import chevronUp from '/icons/chevron-up.svg?raw';
import chevronDown from '/icons/chevron-down.svg?raw';
import { darkModeQuery } from '../../style.js';
import { Styles, componentBaseStyles } from '@adaptive-web/adaptive-ui';

AdaptiveDesignSystem.statics.set(AccordionItemStatics.collapsed, chevronDown);
AdaptiveDesignSystem.statics.set(AccordionItemStatics.expanded, chevronUp);

export class AccordionItem extends FASTAccordionItem {
  public expandedChanged(prev: boolean, next: boolean) {
    Updates.enqueue(() => {
      this.$emit('expanded-change', next);
    });
  }
}

const accordionItemStyles = DesignSystem.assembleStyles([
  componentBaseStyles,
  accordionItemTemplateStyles,
  css`
    :host {
      margin-bottom: calc(var(--padding-xs) / 2);
      border: ${strokeThickness} solid transparent;
      border-radius: ${cornerRadiusLayer};
      contain: content;
    }

    :host .heading {
      padding-top: var(--padding-xs);
      padding-bottom: var(--padding-xs);
      background-color: var(--background-color);
      transition: background-color 200ms ease-in-out;
    }

    :host([expanded]) {
      border-color: var(--primary-color);
    }

    :host(:hover) .heading,
    :host(.hover) .heading {
      background-color: var(--surface-color);
    }

    :host([expanded]) .heading {
      background-color: var(--primary-color);
    }

    :host([expanded]) .heading {
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    
    :host([expanded]) .button {
      color: var(--on-primary-color) !important;
    }

    :host([expanded]) .heading > .icon {
      color: var(--secondary-color);
    }

    :host .region {
      background-color: var(--surface-color);
    }

    .icon {
      color: var(--primary-color);
    }

    svg, svg > path {
      fill: currentColor;
    }

    :host .region {
      border-bottom-right-radius: ${cornerRadiusLayer};
      border-bottom-left-radius: ${cornerRadiusLayer};
    }

    :host(:focus-within) {
      outline: ${focusStrokeThickness} solid ${focusStrokeOuter};
      outline-offset: 1px;

    }

    :host(:focus-within:not([expanded])) .heading {
      background-color: var(--surface-color);
    }
  `.withBehaviors(
    new MatchMediaStyleSheetBehavior(
      darkModeQuery,
      css`
          :host(:hover) .heading,
          :host(.hover) .heading,
          :host([expanded]) .heading {
            background-color: var(--surface-color);
          }

          :host .region {
            background-color: #537494;
          }
  `)),
], AccordionItemAnatomy.interactivity, {
  styleModules: [
    [
      {},
      Styles.compose(
        [
          plainTextStyles,
        ],
      ),
    ],
    [
      {
        part: AccordionItemAnatomy.parts.heading
      },
      Styles.compose(
        [
          controlShapeStyles,
          controlDensityStyles
        ]
      )
    ],
    [
      {
        part: AccordionItemAnatomy.parts.button
      },
      neutralForegroundStrongElementStyles
    ],
    [
      {
        part: AccordionItemAnatomy.parts.icon
      },
      neutralForegroundStrongElementStyles
    ],
    [
      {
        part: AccordionItemAnatomy.parts.region
      },
      controlDensityStyles
    ]
  ],
});

export const customAccordionItemDefinition = AccordionItem.compose({
  name: 'adaptive-accordion-item',
  template: accordionItemTemplate(AdaptiveDesignSystem),
  styles: accordionItemStyles
});